var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_297_821)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.3574 4.82145H8.32136V6.34095H8.36425C8.77701 5.60044 9.78632 4.82145 11.2914 4.82145C14.4212 4.82145 15 6.76918 15 9.30296V14.4643H11.909V9.88899C11.909 8.7983 11.8863 7.39425 10.3017 7.39425C8.69228 7.39425 8.44562 8.58155 8.44562 9.80954V14.4643H5.35738V4.82145H5.3574ZM3.21451 2.14289C3.21451 3.03012 2.49449 3.75014 1.60726 3.75014C0.720037 3.75014 -0.000244141 3.03012 -0.000244141 2.14289C-0.000244141 1.25567 0.720037 0.535645 1.60726 0.535645C2.49449 0.535645 3.21451 1.25567 3.21451 2.14289ZM-0.000244141 4.82145H3.21451V14.4643H-0.000244141V4.82145Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_297_821"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.61f238cbdb9e0b3afad3fa10fb4d67bb.svg";
export { ForwardRef as ReactComponent };